import {z} from 'src/lib'
import {FormOperacionCapitalMarketsDetalleFields, OperacionCapitalMarketsDetalleFields, OperacionCapitalMarketsFields} from "./fields";
import {schemaEntityWithId} from "../../../../../types";

export const schemaOperacionCapitalMarkets = z.object({
  [OperacionCapitalMarketsFields.CodPais]: z.number(),
  [OperacionCapitalMarketsFields.NombrePais]: z.string(),
  [OperacionCapitalMarketsFields.CodEstado]: z.number(),
  [OperacionCapitalMarketsFields.DescEstado]: z.string(),
  [OperacionCapitalMarketsFields.EmisorPreAprobado]: z.boolean(),
  [OperacionCapitalMarketsFields.SectorPrivado]: z.boolean(),
  [OperacionCapitalMarketsFields.Underwriting]: z.boolean(),
  [OperacionCapitalMarketsFields.SuperaLimitesUnderwriting]: z.string(),
  [OperacionCapitalMarketsFields.Limites]: z.string().nullable(),
  [OperacionCapitalMarketsFields.FechaAlta]: z.coerce.date(),
  [OperacionCapitalMarketsFields.IdUsuarioAlta]: z.number(),
  [OperacionCapitalMarketsFields.BitEnvio]: z.boolean(),
  [OperacionCapitalMarketsFields.PermiteEditar]: z.boolean(),
  [OperacionCapitalMarketsFields.PermiteEliminar]: z.boolean(),
  [OperacionCapitalMarketsFields.NombreUsuarioAlta]: z.string(),
  [OperacionCapitalMarketsFields.ApellidoUsuarioAlta]: z.string(),
  [OperacionCapitalMarketsFields.MailUsuarioAlta]: z.string(),

}).merge(schemaEntityWithId)

export type OperacionCapitalMarkets = z.infer<typeof schemaOperacionCapitalMarkets>

export const schemaFormOperacionCapitalMarkets = z.object({
  [OperacionCapitalMarketsFields.CodPais]: z.number(),
  [OperacionCapitalMarketsFields.SectorPrivado]: z.boolean().optional(),
  [OperacionCapitalMarketsFields.EmisorPreAprobado]: z.boolean(),
  [OperacionCapitalMarketsFields.Underwriting]: z.boolean().optional(),
  [OperacionCapitalMarketsFields.SuperaLimitesUnderwriting]: z.string().optional(),
  [OperacionCapitalMarketsFields.Limites]: z.union([z.number(), z.string()]).optional().nullable()
}).refine(data => !(data[OperacionCapitalMarketsFields.SuperaLimitesUnderwriting] === 'Si' && !data[OperacionCapitalMarketsFields.Underwriting]), {
  message: "Supera Limites Underwriting requires Underwriting",
  path: [OperacionCapitalMarketsFields.SuperaLimitesUnderwriting],
}).refine(data => !(data[OperacionCapitalMarketsFields.SuperaLimitesUnderwriting] && data[OperacionCapitalMarketsFields.Limites] === undefined), {
  message: "Limites requires SuperaLimitesUnderwriting",
  path: [OperacionCapitalMarketsFields.Limites],
});

export const shapeSchemaFormOperacionCapitalMarkets = schemaFormOperacionCapitalMarkets._def.schema


export type FormOperacionCapitalMarkets = z.infer<typeof schemaFormOperacionCapitalMarkets>


export const schemaOperacionCapitalMarketsDetalle = z
  .object({
    [OperacionCapitalMarketsDetalleFields.Emisor]: z.string(),
    [OperacionCapitalMarketsDetalleFields.Transaccion]: z.string(),
    [OperacionCapitalMarketsDetalleFields.ValorNominal]: z.string(),
    [OperacionCapitalMarketsDetalleFields.Moneda]: z.string(),
    [OperacionCapitalMarketsDetalleFields.Plazo]: z.string(),
    [OperacionCapitalMarketsDetalleFields.Amortizacion]: z.string(),
    [OperacionCapitalMarketsDetalleFields.FEE]: z.string(),
    [OperacionCapitalMarketsDetalleFields.Colocadores]: z.string(),
    [OperacionCapitalMarketsDetalleFields.Rating]: z.string(),
    [OperacionCapitalMarketsDetalleFields.DestinoDeFondos]: z.string(),
      [OperacionCapitalMarketsDetalleFields.Bridge]: z
          .string()
          .min(1, {message: 'Required'})
          .refine(
              value => value.trim() !== '' && !/^\s*$/.test(value),
              {message: 'Required'}
          ),
    [OperacionCapitalMarketsDetalleFields.Underwriting]: z.string(),
    [OperacionCapitalMarketsDetalleFields.Nota]: z.string(),

    [OperacionCapitalMarketsDetalleFields.LendingDeudor]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingAcreedor]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingMoneda]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingMonto]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingDestino]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingPlazoDisponibilidad]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingPlazo]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingAmortizacion]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingComision]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingPrecancelacion]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingTasaInteres]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingFrecuenciaInteres]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingGarantias]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingCovenants]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingLey]: z.string().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingFechaEjecucion]: z.coerce.date().optional().nullable(),
    [OperacionCapitalMarketsDetalleFields.LendingOtros]: z.string().optional().nullable(),

  })
  .merge(schemaEntityWithId)

export type OperacionCapitalMarketsDetalle = z.infer<typeof schemaOperacionCapitalMarketsDetalle>


export const schemaFormOperacionCapitalMarketsDetalle = schemaOperacionCapitalMarketsDetalle.extend({
  [FormOperacionCapitalMarketsDetalleFields.ListaDestinoDeFondos]: z.array(z.string()).max(3),
  [FormOperacionCapitalMarketsDetalleFields.ListaAmortizacion]: z.array(z.string()).max(3),
});

export type FormOperacionCapitalMarketsDetalle = z.infer<typeof schemaFormOperacionCapitalMarketsDetalle>;